import React, { useEffect, useState } from 'react'
import { useIndexedDB } from '../../../context/IndexedContext'
import HighLightText from '../../../components/shared/HighLightText'

const PoacRecords = ({ patientDBdata, isSavingTheData, diagnosis, patientID, MasterDiagnosisData, loggedUserProvider, setPatientDBdata, noteID }) => {

    const { getCallCenterQuestions, saveCallCenterQuestions } = useIndexedDB()
    const [patientDiagnosis, setPatientDiagnosis] = useState([])
    const [questionValue, setQuestionsValue] = useState({})

    useEffect(() => {
        const patientD = patientDBdata?.patientData?.Diagnosis?.split(',')
        setPatientDiagnosis(patientD)
    }, [])

    const getLatestDataForPoa = (allPatientHpiData, patientID) => {
        const filtered = allPatientHpiData.filter((item) => {
            const patientData = item[patientID]
            return patientData
        })
        const latest = filtered.at(-1)
        return latest || null
    }

    const getCallCenterDatas = async (diagnosisList) => {
        let allData = await getCallCenterQuestions();
        const allPatientHpiData = allData?.Data?.map((item) => {
            return {
                ...JSON.parse(item?.JsonData),
                CreatedAt: item?.CreatedAt,
            };
        });

        const result = getLatestDataForPoa(allPatientHpiData, patientID);
        const callCenterData = result?.[patientID]?.CCENTER;
        setQuestionsValue(callCenterData || {});
        return callCenterData || {};
    };

    const handleSaveCallCenterEdits = async () => {
        let allData = await getCallCenterQuestions();
        const allPatientHpiData = allData?.Data?.map((item) => {
            return {
                ...item,
                JsonData: JSON.parse(item?.JsonData),
            };
        });

        const updatedAllQuestionValue = allPatientHpiData.map((item) => {
            if (item?.JsonData?.[patientID]) {
                return {
                    ...item,
                    JsonData: {
                        ...item?.JsonData,
                        [patientID]: {
                            ...item?.JsonData?.[patientID],
                            CCENTER: questionValue,
                        }
                    }
                }
            }
            return item
        })

        const jsonFormat = updatedAllQuestionValue.map((item) => {
            return {
                ...item,
                JsonData: JSON.stringify(item?.JsonData)
            }
        })

        const dataToPut = {
            IDNumber: '', Data: jsonFormat
        }

        await saveCallCenterQuestions(dataToPut)
    }

    useEffect(() => {
        if (Array.isArray(patientDiagnosis) && patientDiagnosis.length > 0) {
            getCallCenterDatas(patientDiagnosis)
        }
    }, [patientDiagnosis])

    return (
        <div className='d-flex flex-column gap-2'>
            {questionValue?.[diagnosis] && <p className='p-0 m-0 fw-bold' style={{ color: '#ffffff' }}>POA</p>}
            <div className='d-flex flex-column gap-2'>
                {(questionValue?.[diagnosis] || []).map((item, idx) => {
                    const rawLabel = item.label || item.question || ''
                    const cleanLabel = typeof rawLabel === 'string' ? rawLabel.replace(/<[^>]*>/g, '') : rawLabel

                    return (
                        <div key={idx} className='d-flex flex-column gap-1'>
                            {item?.freewayRemark && <div>{item.freewayRemark}</div>}
                            <p className='p-0 m-0' style={{ color: '#ffffff', fontWeight: '500' }}>
                                {item.type === "Header"
                                    ? cleanLabel
                                    : item.type === "subHeader"
                                        ? `${cleanLabel} :`
                                        : `${cleanLabel} -`}
                            </p>
                            {item?.answer !== undefined &&
                                <HighLightText
                                    showHighlightButton={item.type !== 'dropdown'}
                                    style={{ width: '100%', height: "80px", background: '#2D2D2D', color: 'white', border: 0, overflow: "hidden" }}
                                    onBlur={handleSaveCallCenterEdits}
                                    onChange={(e) => {
                                        setQuestionsValue(prev => ({
                                            ...prev,
                                            [diagnosis]: prev?.[diagnosis]?.map((q, i) =>
                                                i === idx
                                                    ? { ...q, answer: e }
                                                    : q
                                            )
                                        }));
                                    }}
                                    value={item?.answer || ''}
                                />
                            }

                            {item.type === 'dropdown' && item.freeType !== undefined && item.freeType !== '' && (
                                <div className="mt-2">
                                    <HighLightText
                                        style={{ width: '100%', height: "80px", background: '#2D2D2D', color: 'white', border: 0, overflow: "hidden" }}
                                        onBlur={handleSaveCallCenterEdits}
                                        value={item.freeType || ''}
                                        onChange={(val) => {
                                            setQuestionsValue(prev => ({
                                                ...prev,
                                                [diagnosis]: prev?.[diagnosis]?.map((q, i) =>
                                                    i === idx
                                                        ? { ...q, freeType: val }
                                                        : q
                                                )
                                            }));
                                        }}
                                        type="textarea"
                                        placeholder="Freetype"
                                    />
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default PoacRecords